import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function MailFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.281 5.58575L11.3126 10.6016C11.7453 10.8179 12.255 10.8179 12.6876 10.6016L22.719 5.58586C22.5193 4.26357 21.3781 3.25 20 3.25H4C2.62202 3.25 1.48076 4.26351 1.281 5.58575Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 7.80658V18C1.25 19.5188 2.48122 20.75 4 20.75H20C21.5188 20.75 22.75 19.5188 22.75 18V7.8067L13.5822 12.3906C12.5864 12.8885 11.4138 12.8885 10.4181 12.3906L1.25 7.80658Z"
				fill="currentColor"
			/>
		</svg>
	);
}

MailFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default MailFilledIcon;
